import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  personImage: {
    width: 85,
    height: 85,
    objectFit: 'cover',
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 10
  },
  agreementHeading: {
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    position: 'relative',
    textShadow: `0px 3px 6px ${theme.palette.grey[100]}`,
    color: theme.palette.primary.dark,
  },
  btnWrapper: {
    '& button': {
      width: '100%'
    }
  },
  checkboxErrorText: {
    color: theme.palette.error.main,
    fontSize: 12
  },
}));
